/*
  FD brand: the seat-comfort drawer.

  The same anatomy as the fabric drawer -- a collapsed summary row that opens a
  slide-over of showcase cards -- and deliberately the same shell: the scrim,
  focus trap, Escape handling and scroll lock all come from
  window.FdChooser.shell (fd-fabric-drawer.js). There is no second copy of any
  of that here.

  What is different, and why this file exists at all: comfort is a LINE-ITEM
  PROPERTY, not a variant option. Dawn knows nothing about it, so nothing
  re-renders when it changes and the row has to repaint its own summary. What
  this file does NOT do is decide anything: picking a card (which commits it
  and closes the panel in one tap, same as the fabric drawer) clicks the
  matching radio in the fieldset below, and the radio -- unchanged, still
  carrying its name, value and form attribute -- is what puts "Seat comfort:
  Firm sit" on the order line. Turn this file off and the fieldset is still a
  complete picker.

  Nothing customer-facing is written here either. The row's label comes from the
  card's own caption and its glyph is cloned from the card's own tile, so the
  row can only ever say what the panel says.
*/
(function () {
  'use strict';

  if (customElements.get('fd-comfort-drawer')) return;

  customElements.define(
    'fd-comfort-drawer',
    class FdComfortDrawer extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('[data-fd-oc-row]');
        this.panel = this.querySelector('.fd-ocpanel');
        this.scrim = this.querySelector('[data-fd-oc-scrim]');
        this.cardsEl = this.querySelector('[data-fd-comfort-cards]');
        this.nameEl = this.querySelector('[data-fd-comfort-name]');
        this.thumbEl = this.querySelector('[data-fd-comfort-thumb]');
        this.fieldset = this.querySelector('.fd-comfort');
        if (!this.row || !this.panel || !this.scrim || !this.cardsEl || !this.fieldset) return;

        this.draft = this.currentIndex();

        this.chooser = window.FdChooser.shell(
          { row: this.row, panel: this.panel, scrim: this.scrim },
          {
            onOpen: () => {
              this.draft = this.currentIndex();
              this.paintDraft();
            }
          }
        );

        this.cards().forEach((card) => {
          if (card.tagName !== 'BUTTON') return;
          card.addEventListener('click', () => {
            this.draft = card.dataset.fdComfortCard;
            this.paintDraft();
            this.commit();
            this.chooser.close();
          });
        });

        // A radio can also be reached without the panel -- keyboard arrows on
        // the no-script fieldset if it is ever shown, or the theme editor
        // re-rendering with a different default -- so the row follows the
        // radios rather than the panel.
        this.fieldset.addEventListener('change', () => this.paintRow());

        this.paintRow();
        this.paintDraft();
      }

      cards() {
        return Array.prototype.slice.call(this.cardsEl.querySelectorAll('[data-fd-comfort-card]'));
      }

      radio(index) {
        return this.fieldset.querySelector('[data-fd-comfort-value="' + index + '"]');
      }

      currentIndex() {
        var checked = this.fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.dataset.fdComfortValue : null;
      }

      paintDraft() {
        this.cards().forEach((card) => {
          if (card.tagName !== 'BUTTON') return;
          card.setAttribute('aria-pressed', String(card.dataset.fdComfortCard === this.draft));
        });
      }

      /*
        The whole commit: click a radio. Everything the customer's choice does
        -- the value that reaches the cart, the checked state, the change event
        this element listens for -- happens on that one line.
      */
      commit() {
        if (!this.draft || this.draft === this.currentIndex()) return;
        var input = this.radio(this.draft);
        if (input && !input.disabled) input.click();
      }

      paintRow() {
        var index = this.currentIndex();
        if (!index) return;
        var card = this.cardsEl.querySelector('[data-fd-comfort-card="' + index + '"]');
        if (!card) return;

        var cap = card.querySelector('.fd-occard__cap');
        var label = cap ? cap.textContent.trim() : '';
        if (this.nameEl && label) this.nameEl.textContent = label;

        var glyph = card.querySelector('.fd-occard__im--glyph svg');
        if (this.thumbEl && glyph) {
          this.thumbEl.textContent = '';
          this.thumbEl.appendChild(glyph.cloneNode(true));
        }

        var legend = this.querySelector('.fd-orow__legend');
        if (label) {
          this.row.setAttribute(
            'aria-label',
            ((legend && legend.textContent.trim()) || 'Seat comfort') + ': ' + label
          );
        }
      }
    }
  );
})();
